// @ts-ignore
import { createApp } from "vue";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import "../src/assets/scss/elements/index.scss";
import App from "./App.vue";
import { registerCKEditor } from "./plugins/ckeditorPlugin";
import registerModules from "./boot/registerModules";
import httpService from "./plugins/httpService";
import VueTransitions from "@morev/vue-transitions";
import "@morev/vue-transitions/styles";
import appConfig from "./plugins/appConfig";
import notification from "./plugins/notification";
import errorHandling from "./plugins/errorHandling";
import customConfig from "./plugins/customConfig";
import schemaGenerator from "./plugins/schemaGenerator";
import VOtpInput from "vue3-otp-input";
import Vue3PersianDatetimePicker from "vue3-persian-datetime-picker";
import mdiVue from "mdi-vue/v3";
import "1llest-waveform-vue/lib/style.css";
// @ts-ignore
import VueMatomo from "vue-matomo";
import { VueQueryPlugin } from "@tanstack/vue-query";

import * as mdijs from "@mdi/js";
import appLangs from "./plugins/appLangs";
import appUtils from "./plugins/appUtils";
import { AVPlugin } from "vue-audio-visual";

import Fa from "element-plus/es/locale/lang/fa";
import "dayjs/locale/fa";
import "toastr/build/toastr.min.css";

const activeModules = (import.meta.env.VUE_APP_ACTIVE_MODULES || "")
  .split(",")
  .filter(Boolean);

const app = createApp(App);
const { router, storeConfig } = registerModules();

registerCKEditor(app);

app
  .use(mdiVue, {
    icons: mdijs,
  })
  .use(ElementPlus, {
    locale: Fa,
  })
  .use(VueTransitions)
  .use(appLangs, { modules: activeModules, currentRoute: router.currentRoute })
  .use(httpService)
  .use(appConfig, { modules: activeModules })
  .use(customConfig)
  .use(notification)
  .use(errorHandling)
  .use(storeConfig)
  .use(schemaGenerator)
  .use(appUtils)
  .use(AVPlugin)
  .use(router)
  .use(VueQueryPlugin, {
    queryClientConfig: {
      defaultOptions: {
        queries: {
          // تنظیمات پیش‌فرض (مثلاً retry، refetchOnWindowFocus، و ...)
        },
      },
    },
  });

if (import.meta.env.VUE_APP_MATOMO_ACTIVE === "true") {
  app.use(VueMatomo, {
    host: import.meta.env.VUE_APP_MATOMO_URL,
    siteId: import.meta.env.VUE_APP_MATOMO_SETSITEID,
    trackerUrl: `${import.meta.env.VUE_APP_MATOMO_URL}/matomo.php`,
    trackerFileName: "matomo",
    router,
    enableLinkTracking: true,
    requireConsent: false,
    trackInitialView: true,
    disableCookies: false,
    debug: false,
  });
}

app
  .component("v-otp-input", VOtpInput)
  .component("date-picker", Vue3PersianDatetimePicker);
if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register("/ServiceWorker.js") // path to your bundled service worker with GoldenRetriever service worker
    .then((registration) => {
      console.log(
        "ServiceWorker registration successful with scope:",
        registration.scope
      );
    })
    .catch((error) => {
      console.log(`Registration failed with ${error}`);
    });
}

app.mount("#app");

export default app;
